module.exports = {
  email: '邮箱',
  role: '角色',
  changeRoleTip: '更新角色后，用户需再次登录才生效。你想保存它吗？',
  userId: '用户ID',
  checkFormat: '请检查电子邮件格式',
  checkNikeEmailFormat: '请输入正确的邮箱',
  deleteUserTip: '您确定要永久删除该用户吗？',
  factoryGroup: '工厂集团'
}
